// extracted by mini-css-extract-plugin
module.exports =  {"root":"KHrI2ggPBTsKvN3zI_8A","carousel":"sUozeNCCm8RtlXvWcZxU"};